import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { ClientService } from "./client.service";
import { ManagerialService } from "./managerial.service";
import { SharedService } from "./shared.service";
import { TenantModel } from "../models/tenant.model";
import { SearchResult } from "../models/search-result.model";
import { ZipModel } from "../models/zip.model";
import { RecommendationsModel } from "../models/recommendations.model";
import { ActiveProcCodeModel } from "../models/active-proc-code.model";
import { ClinicResourceModel } from "../models/clinic-resource.model";
import { ApptProtocolModel } from "../models/appt-protocol.model";
import { ApptProcModel } from "../models/appt-proc.model";
import { CboDefApptResourceModel } from "../models/appt-resource.model";
import { DefApptResourceStrModel } from "../models/appt-resource-str.model";
import { ApptResourceStrModel } from "../models/appt-resource-str.model";
import { ReturnCheckModel } from "../models/return-check.model";
import { CboApptResourceModel } from "../models/appt-resource.model";
import { SalesModel } from "../models/Sales.model";
import { SalesDetailsModel } from "../models/sales-details.model";
import { ClinicSublocationModel } from "../models/clinic-sublocation.model";
import { ClinicDeptModel } from "../models/clinic-dept.model";
import { PetTagHistModel } from "../models/pet-tag-hist.model";
import { DepartmentsModel } from "../models/departments.model";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PersonModel } from "../models/person.model";
declare var $: any;


@Injectable({
    providedIn: "root"
})
export class ClinicService {

    private baseUrl: string = 'clinic';
    zip: ZipModel = new ZipModel('','','','',0); 
    recommendations: RecommendationsModel[] = []
    active_proc_code: ActiveProcCodeModel[] = []
    clinic_resource: ClinicResourceModel[] = []
    appt_protocol: ApptProtocolModel = new ApptProtocolModel(0,'','',0,0,0,0,0,'','','',''); 
    appt_proc: ApptProcModel[] = []
    cbo_def_apptresource: CboDefApptResourceModel[] = []
    def_apptresource_str: DefApptResourceStrModel = new DefApptResourceStrModel('','','')
    apptresource_str: ApptResourceStrModel = new ApptResourceStrModel('','','') 
    return_check: ReturnCheckModel[] = []
    cbo_apptresource: CboApptResourceModel[] = []
    sales_list: SalesModel[] = []
    sales_details: SalesDetailsModel = new SalesDetailsModel(false,'','','','','',0,'')
    return_check_single: ReturnCheckModel = new ReturnCheckModel(0,null,'',0)
    salessub_items = []
    clinic_sublocation: ClinicSublocationModel[] = []
    clinic_sublocation_single: ClinicSublocationModel = new ClinicSublocationModel(0,'','',0,'',0,'','','',0,0)
    clinic_dept: ClinicDeptModel[] = []
    clinic_dept_single: ClinicDeptModel = new ClinicDeptModel('','','',0)
    pet_tag_hists: PetTagHistModel[] = []
    reserveTagList: { 'id':number,'tag_no':string,'pet_no':number,'pet_name':string,'location':string,'sublocation':number,'duration':number,'date':string,'status':string }[] = [];
    reserveTagsOnDate: PetTagHistModel[] = []
    departments: DepartmentsModel[] = []
    departments_single: DepartmentsModel = new DepartmentsModel(0,'','');
    persons: PersonModel[] = []
    person: PersonModel = new PersonModel(0, '', '', '', '', '', '', '', '','',0);
    page_B4_Person = '';
    
    // userData: any = JSON.parse(localStorage['currentUser']);
    // current_clinic:number = this.userData.clinic_no 
    // clinicData: any = (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.current_clinic);

    constructor(
        private api: ApiService,
        private clientService: ClientService,
        private managerialService: ManagerialService,
        private sharedService: SharedService,
    ) {

    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }
    
    get current_clinic(): number {
        return this.userData.clinic_no;
    } 
    
    get clinicData(): any {
        return (JSON.parse(localStorage['clinic'])).find(x => x.clinic_no == this.userData.clinic_no);
    }

    get clinicList(): any {
        return (JSON.parse(localStorage['clinic']));
    }

    getClinicList(): any[] {
        const all = JSON.parse(localStorage['clinic'] || '[]');
        const { role_no, tenant_no, clinic_no } = this.userData;
        if (role_no === 4) return all;
        if (role_no === 1 || role_no === 11) return all.filter((c: any) => c.tenant_no == tenant_no);
        return all.filter((c: any) => c.clinic_no == clinic_no);
    }

    SetupZIP(){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupZIP?zip_code=${this.zip.zip_code}&city=${this.zip.city}&county=${this.zip.county}&state=${this.zip.state}&rab_year=${this.zip.rab_year}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 
 
    GetRecommendations() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetRecommendations?code_clinic=${this.userData.clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.recommendations = res.data.map((element) => {
                            return new RecommendationsModel(element.code_no, element.code_type, element.rec_type, element.code_name);
                        });
                        resolve(1);
                    } else {
                        this.recommendations = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

     GetActiveProcCode() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetActiveProcCode?code_clinic=${this.userData.clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.active_proc_code = res.data.map((element) => {
                            return new ActiveProcCodeModel(element.code_no,element.code_name, element.code_type, element.procedure_desc);
                        });
                        resolve(1);
                    } else {
                        this.active_proc_code = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupRecommend(code_nos: number[], rec_type: string) {   
        const requestBody = {
          code_nos: code_nos,
          rec_type: rec_type,
          code_clinic: this.userData.clinic_no
        };
      
        let promise = new Promise((resolve, reject) => {
          this.api.post(`${this.baseUrl}/SetupRecommend`, requestBody)
            .subscribe((res: any) => { 
                    if (res && res.data) {
                resolve(1);
              } else {
                resolve(0);
              }
            }, (error) => {
              reject(error);
            });
        });
        
        return promise;
      }
      

    // SetupRecommend(code_nos: number[], rec_type: string) {
    //     const promises = code_nos.map((code_no) => {
    //       return new Promise<number>((resolve, reject) => {
    //         this.api
    //           .post(`${this.baseUrl}/SetupRecommend?code_no=${code_no}&rec_type=${rec_type}&code_clinic=${this.userData.clinic_no}`)
    //           .subscribe(
    //             (res: any) => {
    //               if (res && res.data) {
    //                 resolve(1);
    //               } else {
    //                 resolve(0);
    //               }
    //             },
    //             (error) => {
    //               reject(error);
    //             }
    //           );
    //       });
    //     });
      
    //     return Promise.all(promises);
    //   }

    DeleteRecommendations(){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteRecommendations?code_clinic=${this.userData.clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    GetClinicResource() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicResource`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clinic_resource = res.data.map((element) => {
                            return new ClinicResourceModel(element.resource_code, element.resource_name);
                        });
                        resolve(1);
                    } else {
                        this.clinic_resource = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetApptProtocol(appt_proc_code: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptProtocol?appt_proc_code=${appt_proc_code}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        this.appt_protocol = new ApptProtocolModel(res.data.appt_proc_id,res.data.appt_proc_code,res.data.appt_proc_name,res.data.appt_doctor_slots,res.data.appt_room_slots,
                            res.data.addl_doctor_slots,res.data.addl_room_slots,res.data.appt_max,res.data.appt_resource,res.data.appt_code1,res.data.appt_code2,res.data.appt_code3);
                        resolve(1);
                    } else {
                        this.appt_protocol = new ApptProtocolModel(0,'','',0,0,0,0,0,'','','',''); 
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    SetupApptProtocol(){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupApptProtocol`, this.appt_protocol)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
            // resolve(1);
        });
        return promise;
    }  
     
    DeleteApptProtocol(){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteApptProtocol?appt_proc_code=${this.appt_protocol.appt_proc_code}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    getApptProc() {
        let promise = new Promise((resolve, reject) => { 
            this.api.get<SearchResult>(`catalog/?type=${10}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.appt_proc = res.data.map((element) => {
                            return new ApptProcModel(element.appt_proc_id, element.appt_proc_code, element.appt_doctor_slots);
                        }); 
                        resolve(1);
                    } else {
                        this.appt_proc = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
   
    GetTreatmentSchedTimeHour(time_code:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetTreatmentSchedTimeHour?time_code=${time_code}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        resolve(res.data);
                    } else { 
                        resolve('');
                    }
                });
        });
        return promise;
    }

    SetupTimeFile(time_hour:string, time_count:number, time_code:string){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupTimeFile?time_hour=${time_hour}&time_count=${time_count}&time_code=${time_code}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    GetCboDefApptResource(def_appt_weekday:number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCboDefApptResource?def_appt_weekday=${def_appt_weekday}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.cbo_def_apptresource = res.data.map((element) => {
                            return new CboDefApptResourceModel(element.def_appt_resource_id,element.def_appt_resource_code, element.def_appt_resource_category);
                        });
                        resolve(1);
                    } else {
                        this.cbo_def_apptresource = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    GetDefApptResourceStr(def_appt_resource_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetDefApptResourceStr?def_appt_resource_id=${def_appt_resource_id}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        this.def_apptresource_str = new DefApptResourceStrModel(res.data.def_appt_resource_category,res.data.def_appt_resource_time_str,res.data.def_appt_doctor_load);
                        resolve(res.data);
                    } else {
                        this.def_apptresource_str = new DefApptResourceStrModel('','',''); 
                        resolve(res.data);
                    }
                });
        });
        return promise;
    } 
 
    GetReturnCheckList(client_no: number,method_of_pay: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetReturnCheckList?client_no=${client_no}&method_of_pay=${method_of_pay}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {   
                        this.return_check = res.data.map((element) => {
                            return new ReturnCheckModel(element.cashreg_sequence,element.cashreg_date, element.check_card,element.amount_of_pay);
                        });
                        resolve(1);
                    } else {
                        this.return_check = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    SetupCashRegInsert(client_no: number, cashreg_clinic: number, cashreg_date: string, txtAmtPay: number,
        txtCharge: number, check_card: string, cashier: string, cashreg_station: number, invoice_no: number,
        cashreg_check: string, RCHECK: number, RCHECK_FEES: number){  
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupCashRegInsert?client_no=${client_no}&cashreg_clinic=${cashreg_clinic}&cashreg_date=${cashreg_date}&txtAmtPay=${txtAmtPay}&txtCharge=${txtCharge}&check_card=${check_card}&cashier=${cashier}&cashreg_station=${cashreg_station}&invoice_no=${invoice_no}&cashreg_check=${cashreg_check}&RCHECK=${RCHECK}&RCHECK_FEES=${RCHECK_FEES} `)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    SetupCashRegUpdate(cashreg_sequence: number){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupCashRegUpdate?cashreg_sequence=${cashreg_sequence}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    SetupCashRegClientInfo(client_no: number){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupCashRegClientInfo?client_no=${client_no}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  

    GetCboApptResource(appt_resource_date:string, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetCboApptResource?appt_resource_date=${appt_resource_date}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.cbo_apptresource = res.data.map((element) => {
                            return new CboApptResourceModel(element.appt_resource_id,element.appt_resource_code, element.appt_resource_category);
                        });
                        
                        resolve(1);
                    } else {
                        this.cbo_apptresource = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetApptResourceStr(appt_resource_id: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetApptResourceStr?appt_resource_id=${appt_resource_id}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        this.apptresource_str = new ApptResourceStrModel(res.data.appt_resource_category,res.data.appt_resource_time_str,res.data.appt_doctor_load);
                        resolve(res.data);
                    } else {
                        this.apptresource_str = new ApptResourceStrModel('','',''); 
                        resolve(res.data);
                    }
                });
        });
        return promise;
    } 


    SetupDefApptResource(def_appt_resource_id: number,def_appt_resource_code:string,def_appt_resource_category:string,def_appt_weekday:number,def_appt_resource_time_str:string,def_appt_doctor_load:string, clinic_no: number){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupDefApptResource?def_appt_resource_id=${def_appt_resource_id}&def_appt_resource_code=${def_appt_resource_code}&def_appt_resource_category=${def_appt_resource_category}&def_appt_weekday=${def_appt_weekday}&def_appt_resource_time_str=${def_appt_resource_time_str}&def_appt_doctor_load=${def_appt_doctor_load}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  
    
    SetupApptResource(appt_resource_id: number,appt_resource_code:string,appt_resource_category:string,appt_resource_date:string,appt_resource_time_str:string,appt_doctor_load:string, clinic_no:number){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupApptResource?appt_resource_id=${appt_resource_id}&appt_resource_code=${appt_resource_code}&appt_resource_category=${appt_resource_category}&appt_resource_date=${appt_resource_date}&appt_resource_time_str=${appt_resource_time_str}&appt_doctor_load=${appt_doctor_load}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }  
    
    GetSalesList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetSalesList`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.sales_list = res.data.map((element) => {
                            return new SalesModel(element.sales_sequence,element.sale_code);
                        });
                        resolve(1);
                    } else {
                        this.sales_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    GetSalesDetails(sales_sequence:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetSalesDetails?sales_sequence=${sales_sequence}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.sales_details = new SalesDetailsModel(res.data.sale_active,res.data.start_date,res.data.end_date,res.data.start_time,res.data.end_time,res.data.sale_days,res.data.sale_percent,res.data.category);
                        resolve(1);
                    } else {
                        this.sales_details = new SalesDetailsModel (false,'','','','','',0,'')
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    

    GetSalesSub(sales_sequence:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetSalesSub?sales_sequence=${sales_sequence}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.salessub_items = res.data;
                        resolve(1);
                    } else {
                        this.salessub_items = []
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    
    SetupSales(sales_sequence: number,sale_code:string, sale_active:boolean, sale_percent:number, category:number, employee:string, start_date:string , end_date:string , start_time:string , end_time:string , sale_days:string ){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupSales?sales_sequence=${sales_sequence}&sale_code=${sale_code}&sale_active=${sale_active}&sale_percent=${sale_percent}&category=${category}&employee=${employee}&start_date=${start_date}&end_date=${end_date}&start_time=${start_time}&end_time=${end_time}&sale_days=${sale_days}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 
 
    DeleteSalesSub(sales_sequence:number){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/DeleteSalesSub?sales_sequence=${sales_sequence}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }); 
        });
        return promise;
    }  

    InsertSalesSub(sales_sequence:number,item_code:string){   
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/InsertSalesSub?sales_sequence=${sales_sequence}&item_code=${item_code}`)
                .subscribe((res: any) => { 
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                }); 
        });
        return promise;
    } 

    InsertSalesSubArray(item_code: string[], sales_sequence: number) {   
        const requestBody = {
          item_codes: item_code,
          sales_sequence: sales_sequence,
        };
      
        let promise = new Promise((resolve, reject) => {
          this.api.post(`${this.baseUrl}/InsertSalesSubArray`, requestBody)
            .subscribe((res: any) => { 
                    if (res && res.data) {
                resolve(1);
              } else {
                resolve(0);
              }
            }, (error) => {
              reject(error);
            });
        });
        
        return promise;
      }
 
      GetClinicSubLocationByLoc(clinic_dept_code:string) { 
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicSubLocationByLoc?clinic_dept_code=${clinic_dept_code}&clinic_no=${this.current_clinic}`)
                .subscribe((res: any) => { 
                    if (res && res.results > 0) {
                        this.clinic_sublocation = res.data.map((element) => {
                            return new ClinicSublocationModel(element.sublocation_id, element.sublocation_code, element.sublocation_desc, element.specie, element.category, element.occupied, element.type, element.size, element.note, element.clinic_no, element.location_id);
                        });

                        resolve(1);
                    } else {
                        this.clinic_sublocation = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinicSubLocation() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicSubLocationByLoc?clinic_dept_code=${0}&clinic_no=${this.current_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.clinic_sublocation = res.data.map((element) => {
                            return new ClinicSublocationModel(element.sublocation_id, element.sublocation_code, element.sublocation_desc, element.specie, element.category, element.occupied, element.type, element.size, element.note, element.clinic_no, element.location_id);
                        });
                        resolve(1);
                    } else {
                        this.clinic_sublocation = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetClinicSubLocationByLocAll(clinic_dept_code:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetClinicSubLocationByLoc?clinic_dept_code=${clinic_dept_code}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        resolve(res.data)
                    } else { 
                        resolve([]);
                    }
                });
        });
        return promise;
    }

    getClinicDeptByCode(clinic_no:number ,clinic_dept_code:string) {
        return  new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetClinicLocationByCode?clinic_dept_code=${clinic_dept_code}&clinic_no=${clinic_no}`)
            .subscribe((res: any) => {
                resolve(res.data);
            }, (error) => {
                reject(error);
            });
        });
        
    }


    getClinicDept() {
        let promise = new Promise((resolve, reject) => { 
            this.api.get<SearchResult>(`catalog/?type=${16}&sequence=${this.current_clinic}`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        this.clinic_dept = res.data.map((element) => {
                            return new ClinicDeptModel(element.clinic_dept, element.clinic_desc, (element.clinic_dept_code).replace(/\s/g, ""), element.clinic_no);
                        }); 
                        resolve(1);
                    } else {
                        this.clinic_dept = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getClinicDeptByClinicNo(clinic_no:number) {
        let promise = new Promise((resolve, reject) => { 
            this.api.get<SearchResult>(`catalog/?type=${16}&sequence=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {  
                        this.clinic_dept = res.data
                        .map((element) => {
                            return new ClinicDeptModel(
                                element.clinic_dept,
                                element.clinic_desc,
                                (element.clinic_dept_code).replace(/\s/g, ""),
                                element.clinic_no
                            );
                        });
                        //this.clinic_dept = this.clinic_dept.filter(element => element.clinic_no == 1);
                        resolve(1);
                    } else {
                        this.clinic_dept = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
      
    SetupClinicSublocation() {    
        let promise = new Promise((resolve, reject) => {
          this.api.post(`${this.baseUrl}/SetupClinicSublocation`, this.clinic_sublocation_single)
            .subscribe((res: any) => { 
              if (res && res.data) {
                resolve(1);
              } else {
                resolve(0);
              }
            }, (error) => {
              reject(error);
            });
        });
        
        return promise;
      }

      SetupLocation(actionType:number) {     
        let promise = new Promise((resolve, reject) => {
          this.api.post(`${this.baseUrl}/SetupLocation?clinic_dept=${this.clinic_dept_single.clinic_dept}&dept_desc=${this.clinic_dept_single.clinic_desc}&clinic_dept_code=${this.clinic_dept_single.clinic_dept_code}&clinic_no=${this.clinic_dept_single.clinic_no}&ActionType=${actionType}`)
            .subscribe((res: any) => { 
              if (res && res.data) {
                resolve(1);
              } else {
                resolve(0);
              }
            }, (error) => {
              reject(error);
            });
        });
        
        return promise;
      }

      DeleteLocation(clinic_dept:string, clinic_dept_code:string) {     
        let promise = new Promise((resolve, reject) => {
          this.api.post(`${this.baseUrl}/DeleteLocation?clinic_dept=${clinic_dept}&clinic_dept_code=${clinic_dept_code}`)
            .subscribe((res: any) => { 
              if (res && res.data) {
                resolve(1);
              } else {
                resolve(0);
              }
            }, (error) => {
              reject(error);
            });
        });
        
        return promise;
      }
 
      DeleteSubLocation(sub_location:number, clinic_dept_code:string) {     
        let promise = new Promise((resolve, reject) => {
          this.api.post(`${this.baseUrl}/DeleteSubLocation?sub_location=${sub_location}&clinic_dept_code=${clinic_dept_code}`)
            .subscribe((res: any) => { 
              if (res && res.data) {
                resolve(1);
              } else {
                resolve(0);
              }
            }, (error) => {
              reject(error);
            });
        });
        
        return promise;
      }

      getTagsHistPerMonth(month:number,year:number) {
            let promise = new Promise((resolve, reject) => { 
                this.api.get<SearchResult>(`${this.baseUrl}/GetTagsHistPerMonth?month=${month}&year=${year}&clinic_no=${this.current_clinic}`)
                    .subscribe((res: any) => {
                        if (res && res.data) { 
                            this.pet_tag_hists = res.data.map((element) => {
                                return new PetTagHistModel(element.id,element.tag_no,element.pet_no,element.pet_name,element.client_no,element.assign_date,element.done_date,element.location,element.sublocation,element.duration, element.status,element.department,element.done_by);
                            }); 
                            resolve(1);
                        } else {
                            this.pet_tag_hists = [];
                            resolve(0);
                        }
                    });
            });
            return promise;
        } 

        GetTagHistReserveTagsOnDate(location:string,sublocation:number,assign_date:string) {
            let promise = new Promise((resolve, reject) => { 
                this.api.get<SearchResult>(`${this.baseUrl}/GetTagHistReserveTags?location=${location}&sublocation=${sublocation}&assign_date=${assign_date}&ts=${new Date().getTime()}`)
                    .subscribe((res: any) => {
                        if (res && res.data) {  
                            resolve(res.data);
                        } else {
                            this.reserveTagsOnDate = [];
                            resolve([]);
                        }
                    });
            });
            return promise;
        }  
       
        GetClinicDepartment() {
            let promise = new Promise((resolve, reject) => { 
                this.api.get<SearchResult>(`${this.baseUrl}/GetClinicDepartment`)
                    .subscribe((res: any) => {
                        if (res && res.data) { 
                            this.departments = res.data.map((element) => {
                                return new DepartmentsModel(element.dept_id,element.dept_desc,element.dept_note);
                            }); 
                            resolve(1);
                        } else {
                            this.departments = [];
                            resolve(0);
                        }
                    });
            });
            return promise;
        } 

        SetupClinicSubloc_excel(exceldata:ClinicSublocationModel[]) {     
            let promise = new Promise((resolve, reject) => {
              this.api.post(`${this.baseUrl}/SetupClinicSubloc_excel`, exceldata)
                .subscribe((res: any) => { 
                  if (res && res.data) {
                    resolve(1);
                  } else {
                    resolve(0);
                  }
                }, (error) => {
                  reject(error);
                });
            });
            
            return promise;
        }

        SetupDepartment(OpType:number, dept_id:number, dept_desc:string, dept_note:string) {    

            let promise = new Promise((resolve, reject) => {
              this.api.post(`${this.baseUrl}/SetupDepartment?OpType=${OpType}&dept_id=${dept_id}&dept_desc=${dept_desc}&dept_note=${dept_note}`)
                .subscribe((res: any) => { 
                  if (res && res.data) {
                    resolve(1);
                  } else {
                    resolve(0);
                  }
                }, (error) => {
                  reject(error);
                });
            });
            
            return promise;
        }
        
        DeleteAllSublocation(clinic_no:number) {     
            let promise = new Promise((resolve, reject) => {
              this.api.post(`${this.baseUrl}/DeleteAllSublocation?clinic_no=${clinic_no}`)
                .subscribe((res: any) => { 
                  if (res && res.data) {
                    resolve(1);
                  } else {
                    resolve(0);
                  }
                }, (error) => {
                  reject(error);
                });
            });
            
            return promise;
          }

    //#region Person

    openPersonModal(page: string) {
        $('#modalSearchPerson').modal('show');
        this.sharedService.triggerSearchPerson('client','')
        this.page_B4_Person = page
    }

    GetPersonsByParams( last_name, first_name , contact_no , email_address) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetFilteredPerson?last_name=${last_name}&first_name=${first_name}&contact_no=${contact_no}&email_address=${email_address}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.persons = res.data.map((element) => {
                            return new PersonModel(element.person_id, element.last_name, element.first_name, element.contact_no, element.email_address, element.address_1, element.city, element.state, element.zip, element.work_phone, element.image_id);
                        });
                        resolve(1);
                    } else {
                        this.persons = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 
    
    setPersonAsData(){
        if(this.page_B4_Person == 'setup-family'){
            this.clientService.family.last_name = this.person.last_name;
            this.clientService.family.first_name = this.person.first_name;
            this.clientService.family.home_phone = this.person.contact_no; 
        }
        else if(this.page_B4_Person == 'setup-contact'){
            this.clientService.contact.contact_desc = this.person.first_name + ' ' + this.person.last_name;
            this.clientService.contact.contact_no = this.person.contact_no;
        }
        else if(this.page_B4_Person == 'setup-email'){
            this.clientService.client_email_data.email_address = this.person.email_address;
            this.clientService.client_email_data.email_desc = this.person.first_name + ' ' + this.person.last_name;
        }
        else if(this.page_B4_Person == 'setup-client'){
            this.clientService.client.last_name = this.person.last_name;
            this.clientService.client.first_name = this.person.first_name;
            this.clientService.client.home_phone = this.person.contact_no;
            this.clientService.client.email_address = this.person.email_address;
            this.clientService.client.address = this.person.address_1;
            this.clientService.client.city = this.person.city;
            this.clientService.client.state = this.person.state;
            this.clientService.client.zip = this.person.zip;
            this.clientService.client.work_phone = this.person.work_phone;
            this.clientService.client.image_id = this.person.image_id;
            this.sharedService.triggernewClient()
        }
        else if(this.page_B4_Person == 'setup-employee'){
            this.managerialService.employee.clientInfoModel.email = this.person.email_address;
            this.managerialService.employee.clientInfoModel.cellphone = this.person.contact_no;
            this.managerialService.employee.clientInfoModel.address = this.person.address_1;
            this.managerialService.employee.clientInfoModel.city = this.person.city;
            this.managerialService.employee.clientInfoModel.state = this.person.state;
            this.managerialService.employee.clientInfoModel.zip = this.person.zip;
            this.managerialService.employee.clientModel.employee_name = this.person.first_name + ' ' + this.person.last_name; 
        }

    }

    setupPerson(actionType) { 
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupPerson?action_type=${actionType}`, this.person)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    deletePerson(person_id) { 
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePerson?person_id=${person_id}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    } 


    //#endregion
      

    //https://localhost:5001/api/clinic/SetupSales?sales_sequence=2&sale_code=WINWIN&sale_active=true&sale_percent=0&category=0&employee=kaw&start_date=2023-08-08&end_date=2023-08-08&start_time=07:00:00.000&end_time=21:00:00.000&sale_days







     
     
}